export default class CloudDisk {
  // 获取文件列表
  static getCloudDiskList (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/cloudDisks/list', 'post', data, axiosOption, httpOption);
  }

  static createFile (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/cloudDisks/add', 'post', data, axiosOption, httpOption);
  }
  static updateBorrow (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/online/onlineOperation/updateDatasource/oaFormLicenseBorrowtest', 'post', data, axiosOption, httpOption);
  }

  static deleteFile (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/cloudDisks/delete', 'post', data, axiosOption, httpOption);
  }
  static updateFile (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/cloudDisks/update', 'post', data, axiosOption, httpOption);
  }
}
